<!-- TODO bold inboxes with new messages -->

<template>
  <div class="inbox-tree">
    <h3 class="inbox-title">My Chats</h3>
    <div>
      <div
        class="flex no-outline inbox"
        :class="{ active: !activeInbox.inboxId && activeInbox.subInbox === 'open' }"
        @click="activate(null)" >
        <!-- toggle state icon -->
        <span
          v-b-toggle="'inbox-my'"
          class="inbox-icon expand-status no-outline"
          @click.stop />
        <!-- custom inbox icon -->
        <!-- TODO make it dinamic... -->
        <span class="inbox-icon my-inbox-icon" />
        <!-- tel number -->
        <span class="number">Inbox</span>
        <!-- counter -->
        <span class="counter">{{ inboxStats.inbox || "" }}</span>
      </div>
      <b-collapse id="inbox-my">
        <div
          class="flex no-outline inbox indent"
          :class="{ active: !activeInbox.inboxId && activeInbox.subInbox === 'assigned' }"
          @click.stop="activate(null, { folder: 'assigned' })" >
          <!-- custom inbox icon -->
          <span class="inbox-icon my-conversations-icon no-left-margin" />
          <!-- tel number -->
          <span class="number">Assigned to me</span>
          <!-- TODO other subfields should be in here -->
          <!-- counter -->
          <span class="counter">{{ inboxStats.assigned_to_me || "" }}</span>
        </div>
      </b-collapse>
    </div>

    <div
      v-for="branch in currentOrganisation.businesses"
      :key="branch.id" >
      <h3 class="inbox-title">{{ branch.name || "Inbox" }}</h3>
      <div
        class="flex no-outline inbox"
        :class="{ active: activeInbox.inboxId === branch.id && activeInbox.subInbox === 'open' }"
        @click="activate(branch.id)" >
        <!-- toggle state icon -->
        <span
          v-b-toggle="`inbox-${branch.id}`"
          class="inbox-icon expand-status no-outline"
          @click.stop />
        <!-- custom inbox icon -->
        <!-- TODO make it dinamic... -->
        <span
          class="inbox-icon custom-icon"
          style="background-image: url('https://w7.pngwing.com/pngs/207/991/png-transparent-telephone-icon-icon-phone-pic-electronics-image-file-formats-text.png');" />
        <!-- tel number -->
        <span class="number">{{ branch.phone }}</span>
        <!-- counter -->
        <span class="counter">{{ processedStats[branch.id] ? processedStats[branch.id].inbox : "" }}</span>
      </div>
      <b-collapse :id="`inbox-${branch.id}`">
        <div
          class="flex no-outline inbox indent"
          :class="{
            active:
              activeInbox.inboxId === branch.id && activeInbox.subInbox === 'assigned',
          }"
          @click.stop="activate(branch.id, { folder: 'assigned' })" >
          <!-- custom inbox icon -->
          <span class="inbox-icon my-conversations-icon no-left-margin" />
          <span class="number sub-folder">Assigned to me</span>
          <!-- TODO other subfields should be in here -->
          <!-- counter -->
          <span class="counter">{{ processedStats[branch.id] ? processedStats[branch.id].assignedToMe : "" }}</span>
        </div>
      </b-collapse>
    </div>

    <h3 class="inbox-title">Archive</h3>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'OrganizationTree',
  data() {
    return {
      processedStats: {},
    };
  },
  computed: {
    ...mapGetters({
      currentOrganisation: 'organisation/currentOrganisation',
      currentOrganisationLoading: 'organisation/currentOrganisationLoading',
      activeInbox: 'inbox/activeInbox',
      inboxStats: 'inbox/stats',
    }),
  },
  watch: {
    currentOrganisation() {
      this.getInboxStats();
      this.activate(null);
    },
    inboxStats() {
      this.inboxStats.businesses.forEach((business) => {
        const inboxStats = {
          inbox: business.inbox,
          assignedToMe: business.assigned_to_me,
        };
        this.processedStats[business.business_id] = inboxStats;
      });
    },
  },
  mounted() {
    // handled by organisation component
    // this.fetchOrganizationData();
  },
  methods: {
    ...mapActions({
      getInboxStats: 'inbox/getInboxStats',
      setActiveInbox: 'inbox/setActiveInbox',
    }),
    activate(businessId, filters = null) {
      this.setActiveInbox({
        filters,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.inbox-tree {
  margin: 17px 6px 30px 6px;

  .inbox-title {
    font-size: 14px;
    line-height: 1.2;
    color: $blackUltralight;
    margin: 16px 12px 8px;
  }

  .inbox {
    align-items: center;
    border-radius: 14px;
    padding: 6px 12px;
    margin-top: 2px;

    &.indent {
      margin-left: 47px;
    }

    &:hover {
      background-color: $hoverBgLightGray;
      cursor: pointer;
    }

    &.active {
      background-color: $hoverGbGray;
    }

    .inbox-icon {
      width: 15px;
      height: 15px;
      display: block;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      transition: transform 0.3s;
      margin: 0 8px;

      &.expand-status {
        background-image: url('~@/assets/img/icons/arrow.svg');
        background-size: 11px 11px;
        margin: 0;

        &.not-collapsed {
          transform: rotate(90deg);
        }
      }

      &.my-conversations-icon {
        background-image: url('~@/assets/img/settings.svg');
      }

      &.my-inbox-icon {
        background-image: url('~@/assets/img/chat-open.svg');
      }

      &.no-left-margin {
        margin-left: 0;
      }
    }

    .number {
      flex-grow: 1;
      font-size: 14px;
      line-height: 1.2;
    }

    .counter {
      font-size: 14px;
      line-height: 1.2;
    }
  }
}
</style>
